export default "__VITE_ASSET__CDbUJuAm__"